import { ReactNode, useEffect, useState } from "react";
import { MatchListDto, MatchStatus, TournamentDto } from "../../../types/stats";
import { getMatchList, getTournamentByUuid, getTournamentStages } from "../../../api/transport/statsTransport";
import { TeamContext } from "../../../types/common";
import { MatchListTable } from "../../../components/MatchListTable";
import { Loader } from "../../../components/Loader";
import { CalendarEvent } from "../../../components/CalendarCarousel/CalendarEvent";
import { getStaticUrl } from "../../../utils";
import { VideoCameraOutlined } from "@ant-design/icons";

interface MatchListWidgetProps {
    tournamentId: number;
    tournamentUuid?: string;
    seasonId: number;
    teamId?: number;
    teamName?: TeamContext;
}

export const MatchListWidget: React.FC<MatchListWidgetProps> = ({ tournamentId, tournamentUuid, seasonId, teamId, teamName }) => {
    const [mathcList, setMatchList] = useState<MatchListDto>([]);
    const [tounamentInfo, setTournamentInfo] = useState<TournamentDto>();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getMatchList(tournamentId, seasonId, teamId, teamName).then((data) => {
            setMatchList(data);
            setLoading(false);
            setTimeout(() => {
                const scroll = document.querySelector('#scrollTo');
                scroll?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                });
            }, 500);
        }).finally(() => {
            setLoading(false);
        });
    }, [seasonId, tournamentId, teamId, teamName]);


    useEffect(() => {
        if (!tournamentUuid) {
            return;
        }

        getTournamentByUuid(tournamentUuid).then(t => {
            setTournamentInfo(t);
        });
    }, [tournamentUuid])

    if (loading) {
        return <Loader />;
    }

    return (
        <>
            <div className="flex flex-row flex-wrap mx-auto justify-center">
                {mathcList.map(m => {
                    const date = new Date(m.date);
                    const dateTime = (m.preliminaryDate || isNaN(date.getTime())) ? 'Дата не определена' : date.toLocaleDateString('ru-RU', {
                        day: 'numeric',
                        month: 'long',
                        hour: '2-digit',
                        minute: '2-digit',
                    });

                    let scoreNode: ReactNode = '';
                    if (m.status === MatchStatus.FINISHED) {
                        scoreNode = (
                            <div className="flex flex-col items-center gap-1">
                                <span className="text-5xl font-bold">{m.score}</span>
                                {/*m.videoUrl && <a href={m.videoUrl} className="text-3xl font-bold text-sky-950 hover:text-sky-800">
                                    <VideoCameraOutlined />
                                </a>*/}
                            </div>
                        );
                    } else if (m.status === MatchStatus.IN_PROGRESS) {
                        scoreNode = <span className="text-5xl font-bold animate-pulse">LIVE</span>
                    } else if (m.status === MatchStatus.UPCOMING) {
                        //scoreText = '-';
                    } else if (m.status === MatchStatus.СANCELED) {
                        scoreNode = <span className="text-orange-400 text-base">ОТМЕНЕН</span>;
                    }

                    return (
                        <a className="sm:max-w-[320px] w-full active:scale-95 transition-all hover:no-underline" href={m.protocolUrl}>
                            <CalendarEvent
                                name={tounamentInfo?.name || ''}
                                url=""
                                date={dateTime}
                                team1={{
                                    name: m.isHome ? 'Родина' : m.opponentTeamName,
                                    logo: m.isHome ? 'https://fcrodina.com/i/logo.png' : getStaticUrl(m.opponentTeamLogo)
                                }}
                                team2={{
                                    name: !m.isHome ? 'Родина' : m.opponentTeamName,
                                    logo: !m.isHome ? 'https://fcrodina.com/i/logo.png' : getStaticUrl(m.opponentTeamLogo)
                                }}
                                score={scoreNode}
                                matchUrl={m.protocolUrl}
                                ticketUrl={m.tickets}
                                classNames="!text-slate-950 !bg-white border border-solid border-slate-200"
                            />
                        </a>
                    )
                })}
            </div>
            {/*<div className="hidden">
                <MatchListTable data={mathcList} />
            </div>*/}
        </>
    );
}

